module.exports = __webpack_public_path__ + "img/teacherList_en.96de26d9.png";